import React from "react";

const Donatenow = () => (
  <div className="grid grid-cols-1 sm:grid-cols-3 text-white ">
    <div className="bg-[#41c0e0] sm:p-4 text-center ">
        <h3>View our causes</h3>
        <h1 className="text-xl sm:text-3xl  py-2" style={{ fontFamily: "'Playfair Display', serif" }}>Donate Now</h1>
    </div>
    <div className="bg-[#2d98b3]  sm:p-4 text-center ">
        <h3>Became a volunteer</h3>
        <h1 className="text-xl sm:text-3xl py-2" style={{ fontFamily: "'Playfair Display', serif" }}>Join us today</h1>
    </div>
    <div className="bg-[#257b91]  sm:p-4 text-center">
        <h3>View our events</h3>
        <h1 className="text-xl sm:text-3xl py-2" style={{ fontFamily: "'Playfair Display', serif" }}>Get Involved</h1>
    </div>
  </div>
);

export default Donatenow;
